import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryFudge = [];
let galleryRunes = [];
let gallerySirius = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryFudge = importAll(
    (require as any).context("./gallery-fudge", false, /\.(png|jpe?g|svg)$/)
  );
  galleryRunes = importAll(
    (require as any).context("./gallery-runes", false, /\.(png|jpe?g|svg)$/)
  );
  gallerySirius = importAll(
    (require as any).context("./gallery-sirius", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 2 },
          { index: 3, aspectRatio: 1.5 },
          { index: 5, aspectRatio: 1.5 },
          { index: 6, aspectRatio: 1.5 },
          { index: 7, aspectRatio: 0.5 },
          { index: 8, aspectRatio: 0.5 },
          { index: 9, aspectRatio: 0.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/M2QDhVbAgzw"}
      />

      <ReplicaBigTitle title="Sirius - Black as He's Painted?" />

      <ReplicaQuote source="Harry Potter and the Order of the Phoenix">
        He found the page and turned excitedly to the article. This too was
        illustrated by a rather bad cartoon; in fact, Harry would not have known
        it was supposed to be Sirius if it hadn’t been captioned. Sirius was
        standing on a pile of human bones with his wand out. The headline on the
        article read:
        <br />
        <br />
        SIRIUS - Black As He’s Painted?
        <br />
        Notorious Mass Murderer OR Innocent Singing Sensation?
        <br />
        <br />
        Harry had to read this sentence several times before he was convinced
        that he had not misunderstood it. Since when had Sirius been a singing
        sensation?
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        This is the very first article that appeared in the books, introducing
        The Quibbler and establishing its signature style of “reporting.” The
        article is written in full in the book, so naturally, you’ll find the
        exact same text in my replica — with a few additional bits sprinkled
        around to help fill the pages with relevant content. The left page in
        the photos below was designed for the original prop, but since the book
        also describes the article as featuring an illustration of Sirius
        standing on a pile of human bones with his wand drawn, I extended the
        design with a completely new page (on the right) to match the book’s
        description — staying true to both the film and the source material. The
        title "SIRIUS BLACK: Villain or Victim?" is also mentioned specifically
        in the book, which is why I included it on the second page as well.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(gallerySirius)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      {/* --------------- */}

      <ReplicaBigTitle title="Goblins Cooked in Pies!" />

      <ReplicaQuote source="Harry Potter and the Order of the Phoenix">
        Harry finished reading and stared at the page in disbelief. Perhaps it
        was a joke, he thought, perhaps the magazine often printed spoof items.
        He flicked back a few pages and found the piece on Fudge.
        <br />
        " Cornelius Fudge, the Minister of Magic, denied that he had any plans
        to take over the running of the Wizarding Bank, Gringotts, when he was
        elected Minister of Magic five years ago. Fudge has always insisted that
        he wants nothing more than to “cooperate peacefully” with the guardians
        of our gold. BUT DOES HE? Sources close to the Minister have recently
        disclosed that Fudge’s dearest ambition is to seize control of the
        goblin gold supplies and that he will not hesitate to use force if need
        be. “It wouldn’t be the first time, either,” said a Ministry insider.
        “Cornelius ‘Goblin-Crusher’ Fudge, that’s what his friends call him, if
        you could hear him when he thinks no one’s listening, oh, he’s always
        talking about the goblins he’s had done in; he’s had them drowned, he’s
        had them dropped off buildings, he’s had them poisoned, he’s had them
        cooked in pies. . . . "
        <br />
        Harry did not read any further. Fudge might have many faults but Harry
        found it extremely hard to imagine him ordering goblins to be cooked in
        pies.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        The article about Fudge wanting to take over Gringotts is quite detailed
        in both the book and the original prop. I absolutely love the design
        they created for the original prop — and the fact that they stayed
        faithful to the books. Since part of the article appears in the book
        verbatim, I naturally carried that exact text into my replica of the
        pages. However, because Harry never finished reading the article, I had
        to write an extension that would fit the tone and continue the absurd
        narrative about Fudge.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryFudge)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      {/* --------------- */}

      <ReplicaBigTitle title="Secrets of the ancient runes revealed" />

      <ReplicaQuote source="Harry Potter and the Order of the Phoenix">
        ...and an article on ancient runes, which at least explained why Luna
        had been reading The Quibbler upside down. According to the magazine, if
        you turned the runes on their heads they revealed a spell to make your
        enemy’s ears turn into kumquats. In fact, compared to the rest of the
        articles in The Quibbler, the suggestion that Sirius might really be the
        lead singer of The Hobgoblins was quite sensible.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        The upside-down pages featuring a spell to turn your enemy’s ears into
        kumquats were also designed for the original prop, and are actually one
        of the few that appeared in the film itself. For most of the other
        pages, I had to hunt down as much information about the screen-used
        props as possible to figure out which designs existed — many of which
        never made it on screen (which is a shame). So this one was relatively
        straightforward, at least research-wise. Of course, I still had to come
        up with actual text to match the headings and illustrations — and to
        (allegedly) teach you the spell in question, if you follow the steps
        just right.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryRunes)}
        imagesPerRow={4}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      {/* --------------- */}

      <ReplicaBigTitle title="Book-Accurate Articles" />

      <ReplicaQuote source="Harry Potter and the Order of the Phoenix">
        Everyone else was watching Luna laughing, but Harry, glancing at the
        magazine on the floor, noticed something that made him dive for it.
        Upside down it had been hard to tell what the picture on the front was,
        but Harry now realized it was a fairly bad cartoon of Cornelius Fudge;
        Harry only recognized him because of the lime-green bowler hat. One of
        Fudge’s hands was clenched around a bag of gold; the other hand was
        throttling a goblin. The cartoon was captioned: How Far Will Fudge Go to
        Gain Gringotts? Beneath this were listed the titles of other articles
        inside the magazine.
        <br />
        <br />
        CORRUPTION IN THE QUIDDITCH LEAGUE:
        <br />
        How the Tornados Are Taking Control
        <br />
        <br />
        SECRETS OF THE ANCIENT RUNES REVEALED
        <br />
        <br />
        SIRIUS BLACK: Villain or Victim?
        <br />
        <br />
        “Can I have a look at this?” Harry asked Luna eagerly. She nodded, still
        gazing at Ron, breathless with laughter.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        As you might have noticed, this particular issue of The Quibbler is
        described in far more detail in the books than any of the others — even
        listing specific articles that are meant to appear inside, as shown in
        the excerpt above. I combed through every mention of this issue in the
        text to gather every bit of information I could find. Naturally, I
        incorporated all of those references into my replica. Some of the pages
        were already designed for the original prop (see above), while others
        required me to create entirely new designs from scratch — such as the
        article claiming that “the Tutshill Tornados were winning the Quidditch
        League by a combination of blackmail, illegal broom-tampering, and
        torture.”
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
